<template>
   {{ numberOfAvailableEstates }}
</template>

<script lang="ts">
    import { defineComponent, onMounted, ref } from 'vue'
    import { getNumberOfAvailableEstates }     from '@services/estate/estateDataService'

    export default defineComponent({
        setup() {
            const numberOfAvailableEstates = ref<number>(0);

            onMounted(async () => await getNumberOfAvailableEstates()
                .then(amount => numberOfAvailableEstates.value = amount))

            return {
                numberOfAvailableEstates
            }
        }
    })
</script>
